import type { FC } from 'react'

import { SelectString } from '../../core/components/SelectString'

const USER_PARAM_MAP: Record<string, string> = {
  'combi:SYNFRA': 'Synfra',
  'combi:GRONDG': 'GRONDG',
  'combi:SION': 'SION',
  'combi:CINH': 'CINH',
  'combi:Structin Noord': 'Structin Noord',
  'combi:CIAMS': 'CIAMS',
  'combi:Infra-SDO': 'Infra-SDO',
  'combi:Infra-SV': 'Infra-SV',
  'combi:Infrawerk Rijnmond': 'Infrawerk Rijnmond',
  'combi:Combi Brabant': 'Combi Brabant',
  'combi:Combi Limburg': 'Combi Limburg',
  'combi:Infrawerk Zeeland': 'Infrawerk Zeeland',
}

export interface Props {
  onChangeUserParam: (userParam: string) => void
  userParam: string
}

export const ProfileBeheer: FC<Props> = ({ onChangeUserParam, userParam }) => {
  return (
    <SelectString
      label="User parameter"
      value={userParam}
      onChange={onChangeUserParam}
      getOptionLabel={(option) => USER_PARAM_MAP[option] || ''}
      options={Object.keys(USER_PARAM_MAP)}
      disableClearable
      variant="outlined"
      size="medium"
    />
  )
}
